
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { toast, ToastContainer } from 'react-toastify';
import { AppContext } from "../../utils/context/app.context.js";
import processService from "../../services/process.service";



export default function Verify() {
    const appContext = useContext(AppContext);
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const [user] = useState(searchParams.get("user"));
    const [token] = useState(searchParams.get("token"));
    const [isValidating, setValidating] = useState(false);
    const [validated, setValidate] = useState(0);

    function verifyUser(user, token) {
        setValidating(true);
        processService.verify_request({ user, token })
            .then(res => {
                if (res.data) {
                    setValidating(false);
                    setValidate(1);
                }
            })
            .catch(error => {
                setValidating(false);
                if (error.request.status === 406) setValidate(2);
                else if (error.request.status === 407) setValidate(1);
                else setValidate(0);
                appContext.errorHandler(error, toast, t)
            })
    }

    function sendRequest(user) {
      toast.info(t('actions.procesing'),  { autoClose: 1500, theme: "light", });
        processService.mail_verify_request_public({ user })
            .then(res => {
                if (res.data) {
                     toast.dismiss();
                     toast.success(t('actions.sendMail'));
                }
            })
            .catch(error => {
                appContext.errorHandler(error, toast, t)
            })
    }

    useEffect(() => {
        if (user && token) verifyUser(user, token)
    }, [user, token]);

    return (
        <div className="app-container">
            <div className="app-overlay">
                <div className="row m-0 p-o">
                    <div className="container">
                        <div className="row justify-content-center m-5">
                            <div className="col-md-6 col-sm-12">

                                <ToastContainer theme="colored" />
                                <h2>{t("verify.title")}</h2>
                                <hr />
                                {user && token ? <>
                                    {isValidating ? <>
                                        <h5 className="text-center mb-4"> <span style={{ height: 90, width: 90 }} class="spinner-border spinner-border-sm text-warning" role="status" aria-hidden="true"></span></h5>
                                        <h5>{t("verify.validating")}</h5>
                                    </>
                                        : <>
                                            {validated === 0 ? <h5>{t("verify.validated_0")}</h5> : null}
                                            {validated === 1 ? <h5>{t("verify.validated_1")}</h5> : null}
                                            {validated === 2 ? <>
                                                <h5>{t("verify.validated_2")}</h5>
                                                <div className="row">
                                                    <div className="col text-center">
                                                        <button type="submit" className="btn-login" onClick={() => sendRequest(user)}>
                                                           {t('verify.sendRequest')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </> : null}
                                        </>
                                    }
                                </> : <h5>{t("verify.nodata")}</h5>}


                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div >

    );
}
